const isWideAlignment = alignment => {
    return ['text-bottom-image-top', 'text-top-image-bottom', 'center'].includes(alignment);
};

export default isWideAlignment
